import styled from 'styled-components'
import { AutoTable, BaseContainer } from 'secondstep-components'
import { themeGet } from 'styled-system'

export {
  ClassesTooltip,
  GradeTooltip,
  LastLessonTooltip,
  LessonProgressTooltip,
  MarkedDoneTooltip,
  TableHeaderTooltip,
} from 'components/ReportTableHeaderTooltip'

export const ReportsTable = styled(AutoTable)`
  color: ${themeGet('colors.darkGray')};
  border: 2px solid ${themeGet('colors.beaconGray')};
  background-color: white;
  margin-top: 0;

  [class*='AutoTableHeader'],
  [class*='Cell'] {
    line-height: 1;
  }

  [class*='AutoTableHeaderTh'] {
    padding: 0 1.125rem;
    ${themeGet('breakpoints.mobile')} {
      padding-left: ${themeGet('spacing.blue16_1rem')};
      padding-right: ${themeGet('spacing.blue16_1rem')};
    }
    background-color: ${themeGet('colors.beaconGray')};
  }

  [class*='AutoTableHeaderTh']:last-child,
  [class*='Cell']:last-child {
    padding-right: 40px;
  }
  [class*='AutoTableHeaderSpan'] {
    margin-right: ${themeGet('spacing.pink8_0_5rem')};
    padding: 0;
  }
`

export const FlexContainer = styled(BaseContainer)`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: inherit;
  min-width: 0;
`
export const TextHiddenOverflow = styled.div`
  margin: 0;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
export const TextContainer = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`
